import AppContext from "PFApp/app_context";
import { Id } from "PFTypes/id";
import { useContext, useMemo } from "react";

export const useSkillsCustomTypeId = (): Id => {
  const {
    store: { customTypes }
  } = useContext(AppContext);

  const skillsCustomTypeId = useMemo(
    () => customTypes.find(({ name }) => name === "skills")!.id,
    [customTypes]
  );

  return skillsCustomTypeId;
};
